import { RICHPOLL_COLORS } from "../palette";
import { BRAND_FAVICONS } from "../favicons";
import { BRAND_OG_IMAGES } from "../ogImages";
import { RichPollWordmark, RichPollStacked, RichPollCoin } from "../assets/richpoll";
import type { BrandThemeConfig } from "../types";

// RichPoll — the gold/amber white-label.
//
// The coin fills three semantic slots: it is RichPoll's icon-only logo, it
// replaces the spark as the reward glyph, and it is the currency icon wherever
// a money figure is shown. Same picture, three separate fields, so a later
// brand can point them at three different files without touching a component.
export const richPollTheme: BrandThemeConfig = {
  id: "richpoll",
  label: "RichPoll",
  colors: RICHPOLL_COLORS,
  assets: {
    logoWordmark: RichPollWordmark,
    logoStacked: RichPollStacked,
    logoMark: RichPollCoin,
    sparkIcon: RichPollCoin,
    currencyIcon: RichPollCoin,
    favicon: BRAND_FAVICONS.richpoll,
    ogImage: BRAND_OG_IMAGES.richpoll,
    // No RichPoll welcome badge has been supplied, so the rail shows none
    // rather than showing SmartMarket's.
    welcomeBadge: null,
  },
};
